import axiosInstance from "../../axiosInstance";

const BASE = "/elearning/document-access";

/** @returns {Promise<{ exempt: boolean, yearMonth: string, monthlyLimit: number, bonusBalance: number, usedThisMonth: number, allowance: number, remaining: number }>} */
export const getDocumentAccessMe = async () => {
  const { data } = await axiosInstance.get(`${BASE}/me`);
  return data;
};

/** Khóa AES-256 (base64) để giải mã cache bài giảng trên client — từ biến môi trường BE. */
export const getLessonCacheCryptoKey = async () => {
  const { data } = await axiosInstance.get(`${BASE}/lesson-cache-key`);
  return data?.keyBase64 ?? null;
};

/**
 * Admin: cấp thêm lượt (mỗi pack +5).
 * @param {string} employeeId
 * @param {{ packs?: number }} [opts]
 */
export const grantDocumentAccessBonus = async (employeeId, opts = {}) => {
  const { data } = await axiosInstance.post(`${BASE}/employees/${employeeId}/grant-bonus`, {
    packs: opts.packs ?? 1,
  });
  return data;
};

/**
 * Admin: chỉnh hạn mức tháng / miễn trừ.
 * @param {string} employeeId
 * @param {{ monthly_limit?: number, doc_quota_exempt?: boolean }} body
 */
export const patchEmployeeDocumentAccessPolicy = async (employeeId, body) => {
  const { data } = await axiosInstance.patch(`${BASE}/employees/${employeeId}`, body);
  return data;
};

export const getEmployeeDocumentAccessStatus = async (employeeId) => {
  const { data } = await axiosInstance.get(`${BASE}/employees/${employeeId}`);
  return data;
};
